<template>
  <jczh-drawer
    title="查询历史价"
    :visible.sync="visible"
    :direction="direction"
    size="1350px"
    @close="handleClose"
    @confirm="confirm"
  >
    <template v-slot:content>
      <el-form class="m-t-20" :inline="true" size="small" label-suffix="：">
        <!-- <el-form-item label="品目名称">
          <el-input
            v-model="filterForm.itemName"
            placeholder="请输入品目名称"
          />
        </el-form-item> -->
        <el-form-item label="参数型号">
          <el-input
            v-model="filterForm.itemModel"
            placeholder="请输入参数型号"
          />
        </el-form-item>
        <el-form-item label="品牌/制造商">
          <el-input
            v-model="filterForm.itemBrand"
            placeholder="请输入品牌/制造商"
          />
        </el-form-item>
        <el-form-item label="成交时间">
          <el-date-picker
            v-model="timeRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSearch">
            查询
          </el-button>
          <el-button size="small" @click="handleReset">
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <jczh-table-content
        ref="table"
        :data="tableList"
        pagination
        :page.sync="page"
        :limit.sync="size"
        :total="total"
        :option="tableConfig"
        :show-index="false"
        @row-click="selectRow"
      >
        <template v-slot:radio="{ row }">
          <el-radio :value="params.priceId" :label="row.priceId" />
        </template>

        <template v-slot:index="{ row, rowIndex }">
          <span>{{ rowIndex + 1 }}</span>
        </template>

        <template v-slot:noRateWinPrice="{ row }">
          <span>{{ strToThousands(row.noRateWinPrice) }}</span>
        </template>
        <template v-slot:noRateWinTotalPrice="{ row }">
          <span>{{ strToThousands(row.noRateWinTotalPrice) }}</span>
        </template>
      </jczh-table-content>
    </template>

    <template v-slot:footer>
      <el-button @click="visible = false">{{ isEdit ? '取消' : '关闭' }}</el-button>
      <el-button v-if="isEdit" type="primary" @click="confirm">确定</el-button>
    </template>
  </jczh-drawer>
</template>
<script>
import { getItemPricePageApi } from '@/api/project-view/item-price'
import listFilterMixin from '@/mixins/list-filter-mixin'
import { strToThousands } from '@/utils/utils'
import dayjs from 'dayjs'
import DateUtils from '@/utils/date'

export default {
  name: 'LowestPriceDrawer',

  components: {

  },
  mixins: [listFilterMixin],
  model: {
    prop: 'isDrawerShow',
    event: 'change'
  },

  props: {
    isDrawerShow: {
      type: Boolean,
      default: false
    },

    isEdit: {
      type: Boolean,
      default: false
    },

    rowData: {
      type: Object,
      default: () => {
        return null
      }
    },

    /**
     * 是否限制时间必填
     */
    isLimit: {
      type: Boolean,
      default: false
    },

    /**
     * 时间选择配置
     */
    pickerOptions: {
      type: Object,
      default: () => {
        return null
      }
    }
  },

  data() {
    return {
      direction: 'rtl',
      visible: false,
      reverse: true,
      total: 0,
      tableList: [],
      filterForm: {
        // itemName: '',
        itemModel: '',
        itemBrand: '',
        startTime: DateUtils.format(new Date(dayjs().subtract(1, 'year').startOf('date')), 'yyyy-MM-dd HH:mm:ss'),
        endTime: DateUtils.format(new Date(dayjs().endOf('date')), 'yyyy-MM-dd HH:mm:ss')
      },
      tableConfig: [
        {
          label: '',
          prop: 'checked',
          slotName: 'radio',
          width: '40px',
          columnAttrs: { align: 'left' },
          hide: !this.isEdit
        },
        {
          label: '序号',
          prop: '',
          slotName: 'index',
        },
        {
          label: '品目编码',
          prop: 'itemCode',
        },
        {
          label: '品目名称',
          prop: 'itemName',
        },
        {
          label: '采购申请单编号',
          prop: 'requirementCode',
          width: 180,
        },
        {
          label: '参数型号',
          prop: 'itemModel',
        },
        {
          label: '品牌/制造商',
          prop: 'itemBrand',
          width: 150,
        },
        {
          label: '单位',
          prop: 'unitType',
        },
        {
          label: '成交数量',
          prop: 'winNum',
        },
        {
          label: '不含税单价(元)',
          slotName: 'noRateWinPrice',
          width: 150,
        },
        {
          label: '税率(%)',
          prop: 'winTaxRate',
        },
        {
          label: '总价(元)',
          slotName: 'noRateWinTotalPrice',
          width: 100,
        },
        {
          label: '成交供应商',
          prop: 'winSupplierName',
          width: 150,
        },
        {
          label: '成交时间',
          prop: 'winTime',
          width: 150,
        },
      ],
      params: {}
    }
  },
  computed: {
    timeRange: {
      get() {
        return [this.filterForm.startTime, this.filterForm.endTime]
      },
      set(val) {
        if (val?.length) {
          this.filterForm.startTime = val[0]
            ? DateUtils.format(val[0], 'yyyy-MM-dd 00:00:00')
            : ''
          this.filterForm.endTime = val[1]
            ? DateUtils.format(val[1], 'yyyy-MM-dd 23:59:59')
            : ''
        } else {
          this.filterForm.startTime = ''
          this.filterForm.endTime = ''
        }
      }
    }
  },

  watch: {
    isDrawerShow() {
      this.visible = this.isDrawerShow
      if (this.isDrawerShow) {
        this.params = this.rowData?.price || {}
        this.getList()
      }
    },
  },

  methods: {
    strToThousands,

    getList() {
      this.epitaxy()
      const params = Object.assign({}, this.filterForm)
      if (!this.rowData?.itemName) {
        return false
      }

      if (this.isLimit && (!this.filterForm.startTime || !this.filterForm.endTime)) {
        this.$message.warning('请选择成交时间')
        return false
      }

      getItemPricePageApi({
        ...params,
        itemName: this.rowData.itemName,
        isSearch: 1, // 精准搜索
        page: this.page,
        size: this.size
      })
        .then(res => {
          this.tableList = res.data?.records || []
          this.total = res.data?.total || 0

          this.$nextTick(() => {
            const item = this.tableList.find(
              el => el.priceId === this.params?.priceId
            )
            item ? this.$refs.table?.$refs?.table?.setCurrentRow(item) : this.$refs.table?.$refs?.table?.setCurrentRow()
          })
        })
        .catch(err => {
          this.tableList = []
          this.$message.error(err?.message)
        })
    },

    handleClose() {
      // 重置筛选条件
      this.reset()
      this.$emit('change', false)
    },

    confirm() {
      if (this.isEdit) {
        this.$emit('selectHandel', this.params)
      }
      this.handleClose()
    },

    // 设置当前行是否可选
    selectRow(row) {
      this.params = row
    },
  }
}
</script>

<style scoped lang="scss">
.content {
  margin: 10px 0 10px 15px;
}
::v-deep .el-radio__label {
  display: none;
}
</style>
